import styled from '@emotion/styled';
import { spin } from 'src/domains/layouts/shared/Animation.style';

export interface SvgIconPropsType {
    className?: string;
    onClick?: () => void;
}

/** Only for icons in which we do not override the colors. We use for logos, trap icon. */
export const SvgIconOriginal = styled('svg', { label: 'SvgIconOriginal' })<SvgIconPropsType>`
    height: auto;
`;

export const SvgIcon = styled('svg', { label: 'SvgIcon' })<SvgIconPropsType>`
    fill: currentcolor;
    height: auto;
`;

export const SvgIconSpinner = styled(SvgIcon, { label: 'SvgIconSpinner' })`
    animation: ${spin} 1.2s linear infinite;
    transform-origin: 50% 50%;
`;
